import React, { useEffect, useState } from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { getInspection } from 'utils/InspectionsUtils';
import { Inspection } from 'classes';
import SkeletonForm from 'components/Shared/SkeletonForm';

const StaticInspForm = ({ inspectionNumber }) => {
  const [defaults, setDefaults] = useState(null);

  useEffect(() => {
    const asyncEffect = async () => {
      const insp = await getInspection(inspectionNumber);
      setDefaults(insp);
    };
    asyncEffect();
  }, [inspectionNumber]);

  const props = {};
  Inspection.columns.forEach(r => {
    props[r.field] = {
      label: r.title,
      type: r.type === 'date' ? 'string' : r.type,
      format: r.type === 'date' ? 'date' : '',
    }
  });

  const schema = {
    "$id": "https://mfs-portal.azurewebsite.net/contact.schema.json",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "title": inspectionNumber,
    "type": "object",
    "properties": props
  };

  const disabledProperties = Object.keys(schema.properties);

  /* 
  on rare occasions, this component may be reached before the full AppContext is done initializing.
  so this form only renders when there is data in selectedProjectData 
  */
  return (
    <>
      {
        defaults ?
          withExtension(DynamicForm, { schema, defaultValues: defaults, disabledProperties, hiddenProperties: [], readOnly: true, cardElevation: 0, title: true, cardStyles: {borderRadius: 0} }) :
          <SkeletonForm />
      }
    </>
  )

}




export default StaticInspForm;
